import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ExcelExportEvent, GridComponent } from '@progress/kendo-angular-grid';
import * as moment from 'moment';
import { FileListComponent } from 'src/app/CommonComponents/file-list/file-list.component';
import { FileUploadComponent } from 'src/app/CommonComponents/file-upload/file-upload.component';
import { CommonService } from 'src/app/Service/Common.service';
import { FileService, FileUploadLibrary } from 'src/app/Service/file/file.service';
import { MapRoleFeatureService } from 'src/app/Service/map-role-feature/map-role-feature.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { PeerReviewService } from 'src/app/Service/peerReview/peer-review.service';
import { DocDetailsOutput, IImpactInputModel, IImpactListOutputModel, IPeerReviewDedOutputModel, PeerImpactOutputModel } from 'src/app/ViewModel/PeerReviewModel';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { DatePipe } from "@angular/common";
//import { AddImpactDialogComponent } from './add-impact-dialog/add-impact-dialog.component';


@Component({
  selector: 'app-add-impacts',
  templateUrl: './add-impacts.component.html',
  styleUrls: ['./add-impacts.component.css']
})
export class AddImpactsComponent implements OnInit {

  @Input() Data:any;
  @Output() exitFunc: EventEmitter<any> = new EventEmitter();
  public impactList: IImpactListOutputModel[] = [];
  public impactType: IPeerReviewDedOutputModel[] = [];
  public projectData: DocDetailsOutput[] = [];
  public reviewForm!: FormGroup;
  selectionAction: any[] = [];
  impactArray: any[] = [];
  valueArray: any[] = [];
  toggleArray :any= [];
  impactDedId :any= [];
  public memberId !: number;
  public project_Id !: number;
  public groupId !: number;
  public Feature: any[] = [];
  public saveflag: boolean = false;
  public submitflag: boolean = false;
  public impactdate: string = '';
  public enableFilter: boolean = false;
  public disc: string = '';
  public count: number = 1;

  @ViewChild(GridComponent)
  private grid!: GridComponent;
  Roles: any[];

  constructor(private dialog: MatDialog, private impactsListService: PeerReviewService, public notificationService: NotificationService,
    private mapRoleFeatureService: MapRoleFeatureService, private commonService: CommonService, private _formBuilder: FormBuilder, private _fileService: FileService) 
      { this.createReviewForm();
        this.allData = this.allData.bind(this); }

  ngOnInit() {
    this.memberId = this.commonService.getLoggedInUserId();
    this.project_Id = this.commonService.getProjectId();
    this.groupId = this.commonService.getLoggedInUserGroupId();
    this.getImpacts();
    this.impactsListService.getPeerStatus({ strDocNumber: this.Data.requestNo , intUID: this.memberId}).subscribe(res => {
      let response = res.filter(x => x.remarks=="Final Response Submitted");
      let date: Date = new Date(response[0].action_On);
      date.setDate(date.getDate() + 14);
      let datePipe: DatePipe = new DatePipe('en-US');
      this.impactdate = datePipe.transform(date, 'dd-MMM-yyyy');
    });
    this.enableMemberRoleFeatures();
  }

  enableMemberRoleFeatures() {
    this.commonService.getProjectMemberFeatures(this.project_Id, this.memberId, this.groupId).subscribe((res: any[]) => {
      this.Feature = res;
      this.saveflag = this.Feature.some(x => x.feature_Desc == "PR Impacts" && x.feature_Id==600006);
    });
    this.commonService.getProjectMemberRoles(this.project_Id,this.groupId,this.memberId).subscribe((res:any[])=>{
      this.Roles = res;
      this.submitflag = this.Roles.some(x=>x.role_Short_Desc.toUpperCase().trim()=='ECD'.toLocaleUpperCase().trim() || x.role_Short_Desc.toUpperCase().trim()=='MECD'.toLocaleUpperCase().trim());
    });
  }

  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }

  createReviewForm() {
    this.reviewForm = this._formBuilder.group({
      C: new FormControl('', [Validators.required]),
      T: new FormControl('', [Validators.required]),
      OT: new FormControl('', [Validators.required]),
      CS: new FormControl('', [Validators.required]),
      TS: new FormControl('', [Validators.required]),
      VA: new FormControl('', [Validators.required]),
      QS: new FormControl('', [Validators.required,Validators.pattern("^[0-9]*$")]),
      CD: new FormControl('', [Validators.required]),
      IMDCS: new FormControl('', [Validators.required]),
    });
  }

  private getFormValue(form: FormGroup, formControlName: string): any {
    return form.get(formControlName)?.value;
  }

  getImpacts() {
    let obj = {
      'review_No': this.Data.requestNo,
      'project_Id': this.project_Id,
      'group_Id': this.groupId
    }
    this.impactsListService.getReviewImpacts(obj).subscribe((data: PeerImpactOutputModel) => {
      this.impactList = data.impactDetails;
      this.impactType = data.impactType;

      if(this.impactList && this.impactList.length>0)
      {
        this.disc = this.impactList[0].disc_No;
        for(let i=0; i<this.impactList.length; i++)
        {
          
          if(this.disc == this.impactList[i].disc_No)
          { 
            this.impactList[i].disc_No += this.count;
            this.count++; 
          }
          else
          {
            this.count = 1;
            this.disc = this.impactList[i].disc_No
            this.impactList[i].disc_No += this.count;
            this.count++; 
          }
        }
      }
    });
    this.impactArray = [];
    this.valueArray = [];
    this.toggleArray = [];
    this.impactDedId = [];

    let datainput =
    {
      strDocNumber: this.Data.requestNo,
      intUID: this.memberId
    };
    this.impactsListService.getPeerDocView(datainput).subscribe((resDoc: DocDetailsOutput[]) => {
      this.projectData = resDoc;
    });
  }
  
  public viewAttachmentClick(dataItem: any) {
    this.dialog.open(FileListComponent, {
      panelClass: ['mat-dialog-secondary'],
      data: { projectId: this.project_Id, docId: dataItem.comment_Id, revisionNo: 'PRC', libraryName: FileUploadLibrary.WorkflowDocument, 
        createdBy: this.memberId, isDeleteEnable: false },
    });
  }

  onSelectionChange(event: any): void {
    if (event['selectedRows'].length > 0) {
      if(event['selectedRows'][0]['dataItem'].responder_Agreed == 'Comply'){
        event['selectedRows'].forEach((element:any) => {
          element.dataItem.isSelected = true;
          this.selectionAction.push(element.dataItem);
        });
      }
    }
    if (event['deselectedRows'].length > 0) {
      if(event['deselectedRows'][0]['dataItem'].responder_Agreed == 'Comply'){
        event['deselectedRows'].forEach((element:any) => {
          for (let i = 0; i < this.selectionAction.length; i++) {
            if (element.dataItem.comment_Id == this.selectionAction[i].comment_Id) {
              element.dataItem.isSelected = false;
              this.selectionAction.splice(i, 1);
            }
          }
        });
      }
    }
  }

  onValueChange(val: any, dataItem: any) {
    for (let i = 0; i < this.selectionAction.length; i++) {
      if(this.selectionAction[i].comment_Id == dataItem.comment_Id) {
          this.selectionAction[i].evidence_Remarks = val.target.value;
      }
    }
  }

  onChange(dedId:any,val: any){
    if(this.toggleArray.includes(val))
    {
      this.toggleArray.splice(this.toggleArray.indexOf(val),1);
      this.impactDedId.splice(this.impactDedId.indexOf(dedId),1);
    }
    else
    {
      this.toggleArray.push(val);
      this.impactDedId.push(dedId);
    }
  }

  checkDisable(i: any){
    if(this.toggleArray.includes(i))
    {
      return false
    }
    else
    {
      return true
    }
  }

  public viewImpactAttachmentClick(dataItem: any) {
    this.dialog.open(FileListComponent, {
      panelClass: ['mat-dialog-secondary'],
      data: { projectId: this.project_Id, docId: dataItem.comment_Id, revisionNo: 'PRI', libraryName: FileUploadLibrary.WorkflowDocument, 
        createdBy: this.memberId, isDeleteEnable: false },
    });
  }

  uploadAttachmentClick(dataItem: any) {
    const dialog = this.dialog.open(FileUploadComponent, {
      panelClass: 'mat-dialog-secondary',
      width: '50%',
      data: { projectId: this.project_Id, docId: dataItem.comment_Id, revisionNo: 'PRI', moduleName: 'EDMS', libraryName: FileUploadLibrary.WorkflowDocument,
          createdBy: this.memberId, 
          documents: [{ value: dataItem.comment_Id, text: 'EDMS', revisionNo: 'PRI',  task_SNo: 0 }],
          isEditable: false },
    });
    dialog.afterClosed().subscribe((res: any) => {
      const dialog2 = this.dialog.open(FileListComponent, {
      panelClass: ['mat-dialog-secondary'],
      data: { projectId: this.project_Id, docId: dataItem.comment_Id, revisionNo: 'PRI', libraryName: FileUploadLibrary.WorkflowDocument, 
          createdBy: this.memberId, isDeleteEnable: true },
      });
      dialog2.afterClosed().subscribe((res: any) => {
        this._fileService.GetFiles({
          libraryNumber: FileUploadLibrary.WorkflowDocument, value: JSON.stringify(
            { projectId: this.commonService.getProjectId(), docId: dataItem.comment_Id, revisionNo: 'PRI' }
          )
        }).subscribe((_data: any[]) => {
          let x: string;
          _data.length>0 ?  x='Y' : x='N'
          if(dataItem.isAttachment!=x)
          {
            dataItem.isAttachment=x

            let obj : IImpactInputModel = {
              strDocNumber: this.Data.requestNo,
              Save_Type: "PARTIAL",
              impactValues: JSON.stringify(this.valueArray),
              commentRows: JSON.stringify(dataItem),
              impactDetails: JSON.stringify(this.impactArray),
              UID: this.memberId,
            }
            this.impactsListService.postReviewImpacts(obj).subscribe(); 
          }
        });
      });
    });
  }

  // addImpacts() {
  //   let obj: any = {};
  //   obj["impactTypes"] = this.impactType;
  //   // Update Impact value details, when already posted
  //   if (this.valueArray.length > 0) {
  //     obj["valueArray"] = this.valueArray;
  //   }

  //   let dialogRef = this.dialog.open(AddImpactDialogComponent, {
  //     panelClass: 'add-impact-mat-dialog-primary',
  //     data: obj
  //   })
  //   dialogRef.afterClosed().subscribe((data) => {
  //     // Update the selected Impact details
  //     if (data) {
  //       this.impactArray = data.impactArray;
  //       this.valueArray = data.valueArray;
  //     }
  //   });
  // }

  Save() {
    if (this.selectionAction.length > 0) {
      // Check, is Impact already available
      let isImpactAvailable = true;
      this.selectionAction.forEach(comment => {
        if (!comment.impact) {
          isImpactAvailable = false;
        }
      });

      if (this.valueArray.length > 0 || isImpactAvailable) {
        // Get Remarks for comments
        for (let i = 0; i < this.selectionAction.length; i++) {
          if (this.selectionAction[i].evidence_Remarks == null) { this.selectionAction[i].evidence_Remarks = ''; }
        }

        let payload: IImpactInputModel = {
          strDocNumber: this.Data.requestNo,
          Save_Type: "PARTIAL",
          impactValues: JSON.stringify(this.valueArray),
          commentRows: JSON.stringify(this.selectionAction),
          impactDetails: JSON.stringify(this.impactArray),
          UID: this.memberId
        }
        this.impactsListService.postReviewImpacts(payload)
          .subscribe(data => {
            if (data.strErrorMsg == null) {
              this.notificationService.showToast("Peer review impacts updated successfully.", "Success");
              this.getImpacts();
            }
            else {
              this.notificationService.showToast(data.strErrorMsg, "Warning");
            }
          });
      }
      else {
        this.notificationService.showToast("Please enter at least one Impact.", "Warning");
      }
    }
    else {
      this.notificationService.showToast("Please select at least one Comment.", "Warning");
    }
  }

  Submit(){
    this.notificationService.showPopup("Are you sure you want to Submit your Impacts Update?", 'Confirm').then(data => {
      if (data == 'yes') 
      {
        let obj: IImpactInputModel = {
          strDocNumber: this.Data.requestNo,
          Save_Type: "FINAL",
          impactValues: JSON.stringify(this.valueArray),
          commentRows: JSON.stringify(this.selectionAction),
          impactDetails: JSON.stringify(this.impactArray),
          UID: this.memberId,
        }
        this.impactsListService.postReviewImpacts(obj).subscribe(data => {
          if (data.strErrorMsg == null) {
            this.notificationService.showToast("Peer review Final Impacts submitted successfully.", "Success");
            this.exitFunc.emit(true);
          }
          else{
            this.notificationService.showToast(data.strErrorMsg, "Warning");
          }
        });
      }
    });
  }

  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: this.impactList.map((data,indx)=>({
        ...data,
        Discipline_No:data.disc_No,
      }))
    };
    return result;
  }

  public onExcelExport(e: ExcelExportEvent): void {
    const rows = e.workbook.sheets[0].rows;

    e.workbook.sheets[0].columns.forEach(data=>{
      data.width=25
      data.autoWidth=true
      data.textAlign="left"
    })

    for(let i=0;i<rows[0].cells.length;i++) {
      rows[0].cells[i].background = '#6192B1';
      rows[0].cells[i].color = '#FFFFFF';
      rows[0].cells[i].bold = true;
    }

    for(let i=1;i<rows.length;i++) {
      rows[i].cells[0].value = i;
      rows[i].cells[0].textAlign = "left";
      rows[i].cells[6].value = rows[i].cells[6].value ? (moment(rows[i].cells[6].value)).format('DD-MMM-yyyy') : "" 
      rows[i].cells[9].value = rows[i].cells[9].value ? (moment(rows[i].cells[9].value)).format('DD-MMM-yyyy') : "" 
      rows[i].cells[12].value = rows[i].cells[12].value ? (moment(rows[i].cells[12].value)).format('DD-MMM-yyyy') : "" 
      if(rows[i].cells[4].value=='L1')
      { rows[i].cells[4].background = '#ff0000'; }
      if(rows[i].cells[4].value=='L2')
      { rows[i].cells[4].background = '#ffbf00'; }
      if(rows[i].cells[4].value=='L3')
      { rows[i].cells[4].background = '#008000'; }
    }

    rows.unshift({
      cells: [{
        value: "MEP ECD For The Project : "+this.projectData[0].mep_ecd_for_project,
        background: "#ffe699",
        colSpan: 7,
        color: "#333333"
      }]
    })

    rows.unshift({
      cells: [{
        value: "ECD For The Project : "+this.projectData[0].ecd_for_project,
        background: "#ffe699",
        colSpan: 7,
        color: "#333333",
        // borderBottom: { color: "#FFFFFF", size: 3}
        },
        {
          value: this.projectData[0].project_code+" - "+this.projectData[0].project_name,
          background: "#ddebf7",
          colSpan: 10,
          color: "#333333",
          rowSpan: 2,
          verticalAlign: "top",
          textAlign: "center"
      }]
    })
    
    rows[0].cells[0].bold = true;
    rows[1].cells[0].bold = true;
    rows[0].cells[1].bold = true;
  }

}
